import { useState } from 'react';
import s from './CourseCardMini.module.scss';
import { FileManager } from 'components/FileManager/FileManager';
import { useNavigate } from 'react-router-dom';
import { ImageInput } from 'components/ImageInput/ImageInput';
import { clearHTML } from 'utils/clearHTML';

export const CourseCardMini = ({image, title}: any) => {

    // ### State
    
    // ### Effects

    // ### Functions

    // ### Views
    
    return(
        <div 
            className={`${s.card}`} 
        >
            <div 
                className={s.card_image} 
            >
                <ImageInput 
                    styles={{
                        boderRadius: "10px",
                        height: 120,
                        width: "100%",
                        
                    }}
                    values={image}
                    disabled={true}
                />
            </div>

            <div className={s.info}>
                <div className={s.info_title}>
                    <h3 className={s.title_text} dangerouslySetInnerHTML={{__html: title}}></h3>
                </div>
            </div>
        </div>
    )
}